// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "./components/Form.bs.js";
import * as Liff from "./liff/Liff.bs.js";
import * as React from "react";
import * as Button from "./components/Button.bs.js";
import * as Loading from "./components/Loading.bs.js";

var main = "\n  flex flex-col items-center pb-4\n  min-h-screen  bg-main\n";

var container = {
  class: "\n    flex flex-col flex-grow items-center\n    min-h-full w-full px-7\n  ",
  style: {
    maxWidth: "540px"
  }
};

function Layout$Logo(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("img", {
                  className: "pt-8 pb-3",
                  style: {
                    height: "12em"
                  },
                  src: "https://storage.googleapis.com/roza-public-assets/liff/roza_liff_logo.png"
                }));
}

var Logo = {
  make: Layout$Logo
};

function Layout$Hero(Props) {
  return React.createElement("div", {
              className: "flex items-center justify-center w-full"
            }, React.createElement("div", undefined, React.createElement("img", {
                      className: "absolute top-0 right-0",
                      style: {
                        height: "120px"
                      },
                      src: "https://storage.googleapis.com/roza-public-assets/liff/roza_liff_header.png"
                    }), React.createElement(Layout$Logo, {})));
}

var Hero = {
  make: Layout$Hero
};

function Layout$Default(Props) {
  var children = Props.children;
  var heroOpt = Props.hero;
  var hero = heroOpt !== undefined ? heroOpt : false;
  return React.createElement("div", {
              className: main
            }, hero ? React.createElement(Layout$Hero, {}) : null, React.createElement("div", {
                  className: container.class,
                  style: container.style
                }, children));
}

var Default = {
  make: Layout$Default
};

function Layout$Loading(Props) {
  return React.createElement(Layout$Default, {
              children: React.createElement(Loading.make, {})
            });
}

var Loading$1 = {
  make: Layout$Loading
};

function Layout$LogoWithButton(Props) {
  var children = Props.children;
  var button_label = Props.button_label;
  var button_onClickOpt = Props.button_onClick;
  var button_onClick = button_onClickOpt !== undefined ? button_onClickOpt : (function (param) {
        
      });
  return React.createElement(Layout$Default, {
              children: null
            }, React.createElement("div", {
                  className: "py-3"
                }, React.createElement(Layout$Logo, {})), React.createElement("div", {
                  className: "flex-grow w-full"
                }, children), React.createElement(Form.GroupInput.make, {
                  children: React.createElement(Button.make, {
                        label: button_label,
                        onClick: button_onClick
                      })
                }));
}

var LogoWithButton = {
  make: Layout$LogoWithButton
};

function Layout$Error(Props) {
  return React.createElement(Layout$LogoWithButton, {
              children: React.createElement("div", {
                    className: "flex flex-col items-center"
                  }, React.createElement("div", {
                        className: "text-xl font-heading text-center px-3 pt-2"
                      }, "ขออภัย ระบบไม่สามารถใช้งานได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง")),
              button_label: "ปิด",
              button_onClick: (function (param) {
                  return Liff.closeWindow(undefined);
                })
            });
}

var $$Error = {
  make: Layout$Error
};

export {
  main ,
  container ,
  Logo ,
  Hero ,
  Default ,
  Loading$1 as Loading,
  LogoWithButton ,
  $$Error ,
  
}
/* Form Not a pure module */
